import { createFileRoute } from '@tanstack/react-router'
import { MarketingKits } from '@/components/admin/marketing/proactive/MarketingKits'

// Marketing kits (F-MKT-N1). ?kit=<id> opens one kit's builder; bare is the
// list. A search param rather than a path segment, like the Poster Studio's
// ?purpose= — the admin routes have no dynamic segments.
type KitsSearch = { kit?: string }

export const Route = createFileRoute('/admin/marketing/kits')({
  validateSearch: (s: Record<string, unknown>): KitsSearch =>
    typeof s.kit === 'string' && s.kit ? { kit: s.kit } : {},
  component: () => <MarketingKits />,
})
